import { UserRequestsService } from './services/user-requests.service';
import { UserRequestsStoreFacade } from './facades/user-requests-store.facade';
import Vue from 'vue';

export class UserRequestsModule extends Vue {

  Store = new UserRequestsStoreFacade();
  Services = UserRequestsService;

}